import createAction from 'redux-act/lib/createAction';

export const userInfoFetched = createAction('USER_INFO_FETCHED');
export const login = createAction('LOGIN');
export const fetchUserInfo = createAction('FETCH_USER_INFO');
export const loggedOut = createAction('LOGGED_OUT');
export const logout = createAction('LOGOUT');
